// packages block
import clsx from "clsx";
import React from "react";
import { useTranslation } from "react-i18next";
import CloseIcon from "@material-ui/icons/Close";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import RadioButtonUncheckedIcon from "@material-ui/icons/RadioButtonUnchecked";
import {
  Stepper,
  Step,
  StepLabel,
  Button,
  Typography,
  Box,
  StepConnector,
} from "@material-ui/core";
// common block
import SelectedStudentCount from "./notify/components/selectedStudentCount";
// constants, theme, utils and api block
import backButtonIcon from "../../assets/images/back-button-icon.png";

const QontoConnector = withStyles({
  alternativeLabel: {
    top: 10,
    left: "calc(-50% + 5px)",
    right: "calc(50% + 5px)",
  },
  line: {
    borderTopWidth: 3,
    borderRadius: 1,
  },
})(StepConnector);

const useQontoStepIconStyles = makeStyles({
  root: {
    color: "#eaeaf0",
    display: "flex",
    height: 22,
    alignItems: "center",
  },
  active: {
    color: "#0aaee0",
  },
  circle: {
    width: 12,
    height: 12,
    borderRadius: "50%",
    backgroundColor: "#0aaee0",
  },
  completed: {
    color: "#0aaee0",
    width: 15,
    height: 15,
    zIndex: 1,
    fontSize: 18,
  },
});

function QontoStepIcon(props) {
  const classes = useQontoStepIconStyles();
  const { active } = props;

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
      })}
    >
      {active ? (
        <RadioButtonUncheckedIcon className={classes.completed} />
      ) : (
        <div className={classes.circle} />
      )}
    </div>
  );
}

export const PreDialogHeader = ({
  title,
  handleClose,
  showCircularProgressBar,
  showSelectedStudentCount,
  step,
  stepUp,
  stepDown,
  count,
  backbut = false,
  crossBtn = true,
}) => {
  const { t } = useTranslation();
  return (
    <>
      <div
        style={{
          paddingLeft: 45,
          paddingTop: 30,
          display: "flex",
          alignItems: "center",
        }}
      >
        {crossBtn && (
          <Button
            variant={"contained"}
            onClick={step ? stepDown : handleClose}
            style={{
              backgroundColor: backbut ? "transparent" : "rgb(30,173,219)",
              maxWidth: "30px",
              maxHeight: "30px",
              minWidth: "30px",
              minHeight: "30px",
              borderRadius: "3px",
              boxShadow: backbut && "none",
            }}
          >
            {backbut ? (
              <img
                src={backButtonIcon}
                className="backbut"
                style={{ width: 40, cursor: "pointer" }}
                alt="back-button-icon"
              />
            ) : (
              <CloseIcon style={{ color: "white" }} fontSize={"small"} />
            )}
          </Button>
        )}

        <Typography
          display="flex"
          variant="h3"
          style={{
            paddingLeft: 10,
            color: "black",
            width: "100%",
            textAlign: "center",
            marginRight: "5rem",
          }}
        >
          {title ?? ""}
        </Typography>

        {showCircularProgressBar && (
          <div
            style={{
              position: "absolute",
              top: "10px",
              right: "10px",
            }}
          ></div>
        )}

        {showSelectedStudentCount && (
          <div style={{ position: "absolute", top: "8px", right: "10px" }}>
            <SelectedStudentCount count={count} />
          </div>
        )}
      </div>

      {step && (
        <Box display="flex" justifyContent="center" paddingTop={1}>
          {step === 1 && (
            <Typography variant="h6">{t("text_step_one")} </Typography>
          )}
          {step === 2 && (
            <Typography variant="h6">{t("text_step_two")} </Typography>
          )}
          <Stepper
            activeStep={step}
            alternativeLabel
            connector={<QontoConnector />}
            orientation="horizontal"
            style={{ width: "100px", padding: 0 }}
          >
            <Step key="step-one">
              <StepLabel
                StepIconComponent={QontoStepIcon}
                onClick={() => stepDown()}
              ></StepLabel>
            </Step>

            <Step key="step-two">
              <StepLabel
                StepIconComponent={QontoStepIcon}
                onClick={() => stepUp()}
              />
            </Step>
          </Stepper>
        </Box>
      )}
    </>
  );
};
